import React from "react";
import { Container, Row, Col, Image, Card, Badge } from "react-bootstrap";
// import "./Insurance.css";
import checkIcon from "../../assets/img/aboutus/check.svg";
import aboutBackground from "../../assets/img/aboutus/aboutBackground.svg";
import layout from "../../assets/img/faq/layout.svg";
import VideoCarousel from "../homePage/VideoCarousel";
import "./FaqsIntro.css";

const FaqsIntro = () => {
  return (
    <>
      <div className="py-5" style={styles.container}>
        <Container style={{ maxWidth: "1350px", margin: "0 auto" }}>
          <Row
            className="align-items-start" // changed from "align-items-center" to "align-items-start"
            style={{ position: "relative", left: 0, marginLeft: "0px" }}
          >
            {/* Left Column: Image + Floating Cards */}
            {/* <Col lg={4} className="position-relative text-center">
    <div className="uaic-image-wrapper mx-auto">
      <Image
        src={require("../../assets/img/faq/faqBackground.svg")}
        fluid
        className="aboutRightImage"
      />
    </div>
  </Col> */}
            <Col lg={4} className="position-relative mt-5 mt-lg-0 text-center ">
              {/* Circular Image */}
              <div className="uaic -image-wrapper mx-auto">
                <Image
                  src={require("../../assets/img/faq/faqBackground.svg")}
                  fluid
                  className="aboutLeftImage"
                  alt="Faq Background Image"
                />
              </div>
            </Col>

            {/* Right Column: Text Content */}
            <Col
              lg={8}
              className="d-flex flex-column justify-content-start text-start"
              style={{ paddingLeft: "40px" }}
            >
              <p
                style={{
                  color: "#17252E",
                  fontSize: "16px",
                  lineHeight: "140%",
                  fontWeight: 600,
                  whiteSpace: "nowrap",
                  position: "relative",
                  display: "inline-block",
                }}
              >
                <span style={{ position: "relative", paddingBottom: "5px" }}>
                  FAQ's
                  <span
                    style={{
                      position: "absolute",
                      left: 0,
                      bottom: -5,
                      height: "1.6px",
                      width: "55%",
                      backgroundColor: "#0e72d6",
                      transform: "translateX(0%)",
                    }}
                  />
                </span>
              </p>

              <h2
                className="mt-2"
                style={{
                  color: "#17252E",
                  lineHeight: "1",
                  fontWeight: "bold",
                  fontSize: "40px",
                }}
              >
                Frequently Asked Questions on Claims
              </h2>

              <p className="mb-4 text-secondary">
                Have questions about filing a claim? Our Claim FAQ section
                provides all the answers you need, guiding you through the
                process step by step. Whether you’re a customer or filing for
                the first time, we’ve got you covered.
              </p>

              <ul
                className=" flex-wrap gap-3"
                style={{ listStyle: "none", padding: 0, margin: 0 }}
              >
                {[
                  "Short videos on how to report claims and get claim status from our Claims Portal",
                  "Answers to most common questions",
                ].map((item, i) => (
                  <li
                    key={i}
                    style={{
                      marginBottom: "12px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={checkIcon}
                      alt="check"
                      style={{ width: "18px", marginRight: "10px" }}
                    />
                    <span className="aboutTextStyle">{item}</span>
                  </li>
                ))}
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
    // backgroundImage: `url(${aboutBackground})`,
    backgroundImage: `url(${layout})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    // background: "linear-gradient(to bottom, #E1FAFF, #FFFFFF)"
  },
  container1: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
  },
};

export default FaqsIntro;
